// Cart Drawer Personal Protocol – reads from window.currentProtocol

// ── Protocol display config ────────────────────────────────────────
const protocolGoalConfig = {
  energy: {
    label: 'Energy',
    metrics: 'HRV · Recovery · Fatigue',
    icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon></svg>'
  },
  sleep: {
    label: 'Sleep',
    metrics: 'Sleep Score · HRV · RHR',
    icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path></svg>'
  },
  fitness: {
    label: 'Fitness',
    metrics: 'VO2 Max · HRV · PHR',
    icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 20V10"></path><path d="M12 20V4"></path><path d="M6 20v-6"></path></svg>'
  },
  endurance: {
    label: 'Endurance',
    metrics: 'VO2 Max · HRV · PHR',
    icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon></svg>'
  }
};

const protocolPlanConfig = {
  'month':   { months: 1, frequencyLabel: 'Billed monthly' },
  '2-month': { months: 2, frequencyLabel: 'Billed every 2 months' },
  '3-month': { months: 3, frequencyLabel: 'Billed every 3 months' }
};

// ── Open / Close ────────────────────────────────────────────────────

function openCartProtocol(shouldDelay = false) {
  try {
    const cartDrawer = document.getElementById('cart-drawer-personal-protocol');
    if (!cartDrawer) { console.warn('Cart drawer element not found'); return; }

    const open = () => {
      cartDrawer.classList.add('open');
      document.body.style.overflow = 'hidden';
      updateCartDrawerContentProtocol();
    };

    if (shouldDelay) {
      setTimeout(open, 1000);
    } else {
      open();
    }
  } catch (error) {
    console.error('Error opening cart drawer:', error);
  }
}

function closeCartProtocol() {
  try {
    const cartDrawer = document.getElementById('cart-drawer-personal-protocol');
    if (cartDrawer) {
      cartDrawer.classList.remove('open');
      setTimeout(() => { document.body.style.overflow = ''; }, 400);
    }
  } catch (error) {
    console.error('Error closing cart drawer:', error);
  }
}

// ── Render drawer content from currentProtocol ──────────────────────

function updateCartDrawerContentProtocol() {
  try {
    renderGoalCard();
    renderPlanCard();
    renderTotalRow();
  } catch (error) {
    console.error('Error updating cart drawer content:', error);
  }
}

// ── Goal card ───────────────────────────────────────────────────────

function renderGoalCard() {
  const goal = window.currentProtocol && window.currentProtocol.start_protocol;
  const config = goal && protocolGoalConfig[goal];

  const nameEl = document.getElementById('cdpp-goal-name');
  const metricsEl = document.getElementById('cdpp-goal-metrics');
  const iconEl = document.getElementById('cdpp-goal-icon');

  if (config) {
    if (nameEl) nameEl.textContent = config.label;
    if (metricsEl) metricsEl.textContent = config.metrics;
    if (iconEl) iconEl.innerHTML = config.icon;
  } else {
    if (nameEl) nameEl.textContent = goal ? goal.charAt(0).toUpperCase() + goal.slice(1) : '—';
    if (metricsEl) metricsEl.textContent = '';
    if (iconEl) iconEl.innerHTML = '';
  }
}

// ── Plan card ───────────────────────────────────────────────────────

function renderPlanCard() {
  const plan = window.currentProtocol && window.currentProtocol.plan;
  const planCfg = plan && protocolPlanConfig[plan];

  const frequencyEl = document.getElementById('cdpp-plan-frequency');
  const priceEl = document.getElementById('cdpp-plan-price');
  const savingsEl = document.getElementById('cdpp-plan-savings');

  if (!planCfg) {
    if (frequencyEl) frequencyEl.textContent = '—';
    if (priceEl) priceEl.textContent = '—';
    if (savingsEl) savingsEl.style.display = 'none';
    return;
  }

  if (frequencyEl) frequencyEl.textContent = planCfg.frequencyLabel;

  const cc = getCurrencyCodeProtocol();
  const prefix = getCurrencyPrefixProtocol(cc);
  const monthlyPrice = getPlanMonthlyPrice(plan, cc);
  const totalPrice = monthlyPrice * planCfg.months;

  if (priceEl) {
    priceEl.textContent = prefix + formatProtocolPrice(totalPrice, cc);
  }

  // Savings compared to monthly plan
  const monthlyBase = getPlanMonthlyPrice('month', cc);
  if (monthlyBase > 0 && planCfg.months > 1) {
    const wouldPay = monthlyBase * planCfg.months;
    const saved = wouldPay - totalPrice;
    if (saved > 0) {
      if (savingsEl) {
        savingsEl.textContent = 'Save ' + prefix + formatProtocolPrice(saved, cc);
        savingsEl.style.display = 'inline';
      }
    } else {
      if (savingsEl) savingsEl.style.display = 'none';
    }
  } else {
    if (savingsEl) savingsEl.style.display = 'none';
  }
}

// ── Total row ───────────────────────────────────────────────────────

function renderTotalRow() {
  const plan = window.currentProtocol && window.currentProtocol.plan;
  const planCfg = plan && protocolPlanConfig[plan];

  const totalLabelEl = document.getElementById('cdpp-total-label');
  const totalPriceEl = document.getElementById('cdpp-total-price');

  if (!planCfg) {
    if (totalPriceEl) totalPriceEl.textContent = '—';
    return;
  }

  const cc = getCurrencyCodeProtocol();
  const prefix = getCurrencyPrefixProtocol(cc);
  const monthlyPrice = getPlanMonthlyPrice(plan, cc);
  const totalPrice = monthlyPrice * planCfg.months;

  if (totalLabelEl) {
    if (planCfg.months === 1) {
      totalLabelEl.textContent = 'Total charged (monthly)';
    } else {
      totalLabelEl.textContent = 'Total charged (every ' + planCfg.months + ' months)';
    }
  }

  if (totalPriceEl) {
    const symbol = getCurrencySymbolProtocol(cc);
    totalPriceEl.textContent = symbol + formatProtocolPrice(totalPrice, cc);
  }
}

// ── Change Goal / Switch Plan ───────────────────────────────────────

function handleChangeGoal() {
  const path = window.location.pathname;
  if (path.indexOf('/pages/choose-your-goal') !== -1) {
    closeCartProtocol();
  } else {
    window.location.href = '/pages/choose-your-goal';
  }
}

function handleSwitchPlan() {
  const path = window.location.pathname;
  if (path.indexOf('/pages/choose-your-plan') !== -1) {
    closeCartProtocol();
  } else {
    window.location.href = '/pages/choose-your-plan';
  }
}

// ── Checkout ────────────────────────────────────────────────────────

async function goToCheckoutProtocol() {
  try {
    const checkoutButton = document.querySelector('.cdpp-cart-checkout-btn');
    const checkoutBtnText = document.getElementById('checkout-btn-text');

    const result = await globalGoToCheckoutProtocol({
      onSuccess: () => {},
      onError: (error) => {
        const errorMessage = error.message || 'There was an error processing your checkout. Please try again.';
        alert(errorMessage);
        console.error('Checkout error details:', error);
      }
    }, checkoutButton, 'Processing...');

  } catch (error) {
    console.error('Error during checkout:', error);
    alert('There was an error processing your checkout. Please try again.');
  }
}

// ── Currency helpers ────────────────────────────────────────────────

function getCurrencyCodeProtocol() {
  return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'SGD';
}

function getCurrencyPrefixProtocol(code) {
  var map = { SGD: '$', AUD: 'A$', HKD: 'HK$', MYR: 'RM', IDR: 'Rp' };
  return map[code] || '$';
}

function getCurrencySymbolProtocol(code) {
  var map = { SGD: 'S$', AUD: 'A$', HKD: 'HK$', MYR: 'RM', IDR: 'Rp' };
  return map[code] || '$';
}

function getPlanMonthlyPrice(plan, currencyCode) {
  if (typeof priceProtocolConverted === 'undefined') return 0;
  var planPrices = priceProtocolConverted[plan];
  if (!planPrices) return 0;
  return planPrices[currencyCode] || planPrices.DEFAULT || 0;
}

function formatProtocolPrice(amount, currencyCode) {
  if (currencyCode === 'IDR') {
    var inK = Math.floor(amount / 1000);
    return inK.toLocaleString('en-US') + 'k';
  }
  return amount.toLocaleString('en-US');
}
